import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'app-modal-warning',
    templateUrl: './modal-warning.component.html',
    styleUrls: ['./modal-warning.component.scss'],
    standalone: false
})
export class ModalWarningComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  closeDialog() {
    this.dialogRef.close('close');
  }

}
